var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgWarrning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.95 195.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warrning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.69,142.84h0a8.94,8.94,0,0,0,8.94-8.94h0V63a8.94,8.94,0,0,0-17.88,0v71A8.94,8.94,0,0,0,109.69,142.84Z",
    transform: "translate(0 -0.01)",
    fill: "#00a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109.98,
    cy: 157.56,
    r: 10.35,
    fill: "#00a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110,189.48v-5.74H17.78a6.57,6.57,0,0,1-2.55-.52,6.36,6.36,0,0,1-3.18-3.16,6.14,6.14,0,0,1,.27-5.8l46.07-79.8,46.08-79.81a6.63,6.63,0,0,1,1.08-1.4,5.93,5.93,0,0,1,2-1.31,6.54,6.54,0,0,1,5.45.34,6,6,0,0,1,1.3,1,6.63,6.63,0,0,1,1.08,1.4l46.08,79.81,46.07,79.8a6.15,6.15,0,0,1,.4,5.52,6.54,6.54,0,0,1-2.25,2.84,6,6,0,0,1-1.64.81,6.48,6.48,0,0,1-2,.31H110V195.2h92.15A17.85,17.85,0,0,0,220,177.37a17.66,17.66,0,0,0-2.4-8.88L171.47,88.71,125.4,8.91a18.22,18.22,0,0,0-3-3.88,17.74,17.74,0,0,0-5.84-3.78,18,18,0,0,0-15.25,1,17.44,17.44,0,0,0-3.76,2.8,18.22,18.22,0,0,0-3,3.88L48.48,88.71,2.4,168.52A17.66,17.66,0,0,0,0,177.4,17.91,17.91,0,0,0,7.6,192a17.52,17.52,0,0,0,4.74,2.36,17.94,17.94,0,0,0,5.44.82H110Z",
    transform: "translate(0 -0.01)",
    fill: "#fc3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrning);
export default __webpack_public_path__ + "static/media/warrning.d6960b2c5f5230e795ebfc053db94eb3.svg";
export { ForwardRef as ReactComponent };